import { styled } from "@mui/material";
import { TableContext } from "../..";
import Preferences from "../../Preferences";
import CheckBox from "../../CheckBox";
import { useContext } from "react";
import Sort from "../../Sort";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { SearchIcon2 } from "assets/icons/SearchIcon";

export default function Header() {
  const table = useContext(TableContext);
  const { onCheckAll, checkedAll } = table;
  const textColor = table.textColor?.header;
  return (
    <thead>
      <tr style={{ position: "relative" }}>
        {table.withCheckBox && (
          <StyledTh
            fixRight
            first
            bgColor={table.bgColor}
            textColor={textColor}
            style={{ textAlign: "center", minWidth: 53, width: 53, padding: 5 }}
          >
            <CheckBox onChange={onCheckAll} active={checkedAll === 1} indeterminate={checkedAll === 3} />
          </StyledTh>
        )}
        <StyledTh
          fixRight
          first
          bgColor={table.bgColor}
          textColor={textColor}
          style={{ textAlign: "center", width: "45px", right: table.withCheckBox ? 53 : 0 }}
        >
          #
        </StyledTh>
        {table.headers?.map((header, index) => {
          return (
            <StyledTh
              key={index}
              style={header.style}
              fixRight={header.fixRight}
              fixLeft={header.fixLeft}
              last={table.withoutMenu && index === (table.headers?.length || 0) - 1}
              bgColor={table.bgColor}
              textColor={textColor}
            >
              <div className="flex items-center gap-2">
                {table.withSort && (
                  <Sort
                    onSort={(dir) =>
                      table.setState && table.setState((x) => ({ ...x, sortDir: dir, sortKey: index }))
                    }
                  />
                )}
                <span>{header.label}</span>
              </div>
            </StyledTh>
          );
        })}
        {/* if problem in modal ui use this  */}
        {/* {!table.withoutMenu && (
          <StyledTh fixLeft last bgColor={table.bgColor} textColor={textColor}>
            {table.preferences ? <Preferences data={table.preferences} /> : <></>}
          </StyledTh>
        )} */}
        {!table.withoutMenu && (
          <StyledTh  last bgColor={table.bgColor} textColor={textColor}>
            {table.preferences ? <Preferences data={table.preferences} /> : <></>}
          </StyledTh>
        )}
      </tr>
      {table.withSearch && (
        <tr>
          {table.withCheckBox && (
            <StyledTh
              fixRight
              first
              bgColor={table.bgColor}
              textColor={textColor}
              style={{ textAlign: "center", width: 53, padding: 5 }}
              className="border border-b-0 border-r-0 border-slate-200"
            ></StyledTh>
          )}
          <StyledTh
            fixRight
            first
            bgColor={table.bgColor}
            textColor={textColor}
            style={{ textAlign: "center", minWidth: 45, width: 53, right: table.withCheckBox ? 53 : 0 }}
            className="border border-b-0 border-r-0 border-slate-200"
          ></StyledTh>
          {table.headers?.map((_header, index) => {
            return (
              <StyledTh
                key={index}
                bgColor={table.bgColor}
                className="p-0 border border-b-0 border-r-0 border-slate-200"
              >
                <BasicTextInput
                  style={{ border: "none" }}
                  onChange={(val) =>
                    table.setState &&
                    table.setState((x) => ({ ...x, searchText: `${val}`, searchKey: index }))
                  }
                  suffix={
                    <div className="flex items-center justify-center w-3 h-3">
                      <SearchIcon2 color="#747575" scale={1} />
                    </div>
                  }
                />
              </StyledTh>
            );
          })}
          {!table.withoutMenu && (
            <StyledTh fixLeft last bgColor={table.bgColor} textColor={textColor}></StyledTh>
          )}
        </tr>
      )}
    </thead>
  );
}

interface StyledThProps {
  fixLeft?: boolean;
  fixRight?: boolean;
  last?: boolean;
  first?: boolean;
  bgColor?: string;
  textColor?: string;
}

// const borderStyle = "1px solid rgba(174, 174, 174, 0.3)";
const borderStyle = "0px";

const StyledTh = styled("th")((props: StyledThProps) => ({
  padding: "10px",
  backgroundColor: props.bgColor || "#F2F5FC",
  borderTop: borderStyle,
  borderBottom: borderStyle,
  fontSize: 14,
  color: props.textColor || "#7E8C9E",
  ...(props.fixLeft && {
    position: "sticky",
    left: 0,
    top: 0,
    zIndex: 1,
  }),
  ...(props.fixRight && {
    position: "sticky",
    right: 0,
    top: 0,
    zIndex: 1,
  }),
  ...(props.first && {
    borderRight: borderStyle,
    // borderTopRightRadius: "6px",
  }),
  ...(props.last && {
    borderLeft: borderStyle,
    // borderTopLeftRadius: "6px",
  }),
}));
